import React from "react";

const ToggleSwitch = ({onClick, text, value, cssClasses, disabled = false}) => {
    return (
        <div className={`toggle-switch-container`}>
            <div className={`flex`}>
                <div className={`toggle-switch-div ${cssClasses} ${disabled && `disabled`}`}
                     data-testid={'toggle-switch-div'}
                     onClick={() => onClick()}>
                    <input type={"checkbox"}
                           data-testid={'checkbox-input'}
                           disabled={disabled}/>
                    <span data-testid={'slider'}
                          className={`slider ${value ? 'on' : 'off'}`}/>
                </div>
                <div className={`toggle-switch-label`}>{text}</div>
            </div>
        </div>
    );
};

export default ToggleSwitch;
